var r="@hpstellar/core/order-summary";export{r as orderSummaryTestId};
